// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1zA0j","icon":"styles_icon__30LAj","text":"styles_text__22LeW","number":"styles_number__HPpNz"};